import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import jwt_decode from 'jwt-decode'
import qs from 'query-string'
import { useDispatch } from 'react-redux'

import LoopedLogin from 'components/LoopedLogin'

import { signIn } from 'store/AppState/actions'
import { isOutsideIframe, setToken, isLoopedLogin } from 'utils/auth'

const OAuthCallback = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const login = token => {
    const decodedToken = jwt_decode(token)

    const user = {
      email: decodedToken.email,
      fullName: decodedToken.name,
      id: decodedToken.sub,
      appRole: decodedToken.app_role
    }

    setToken(token, decodedToken.exp)
    dispatch(signIn(user))
  }

  useEffect(() => {
    const parsedData = qs.parse(window.location.hash)

    if (parsedData) {
      const { access_token } = parsedData

      if (access_token && !isLoopedLogin()) {
        login(access_token)

        if (isOutsideIframe()) {
          setTimeout(() => {
            history.push('/')
          }, 200)
        }
      }
    }
  }, [])

  return isLoopedLogin() ? <LoopedLogin /> : <div>Authenticating</div>
}

export default OAuthCallback
